import NutritionSettings from './NutritionSettings';

export default NutritionSettings;
